import * as Sentry from "@sentry/react";
import { createBrowserHistory } from "history";
import React from "react";
import ReactDOM from "react-dom";
import { hotjar } from "react-hotjar";
import { VERSION } from "utils/constants";
import { App } from "./App";
import "./i18n";
import "./index.scss";

if (process.env.REACT_APP_ENV === "prod") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV,
    tracesSampleRate: 0.3,
    release: VERSION,
    integrations: [Sentry.browserTracingIntegration()],
  });

  window.onerror = (message, source, lineno, colno, error) => {
    Sentry.captureException(error || new Error(String(message)));
    return true;
  };

  window.onunhandledrejection = (event) => {
    Sentry.captureException(event.reason);
  };
}

if (
  process.env.REACT_APP_ENV === "preprod" ||
  process.env.REACT_APP_ENV === "prod"
) {
  hotjar.initialize(
    parseInt(process.env.REACT_APP_HOTJAR_ID, 10),
    parseInt(process.env.REACT_APP_HOTJAR_SV, 10)
  );
}

const replaceHashPath = () => {
  const history = createBrowserHistory();
  const hash = history.location.hash;
  if (hash) {
    const path = hash.replace(/^#/, "");
    if (path) {
      history.replace(path);
    }
  }
};
replaceHashPath();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
